import {Empty, Table, Tooltip, Typography} from 'antd'
import {DeleteOutlined, EditOutlined} from '@ant-design/icons'
import {useIntl} from 'react-intl'
import {formatEmptyValue} from '../../../utils/common'
import RecordsCount from '../../common/RecordsCount'
import TableActions from '../../common/TableActions'

const DeviceConnectionTable = ({
  dataSource,
  pagination,
  getDeviceConnectionsData,
  onEdit,
  onDelete,
}) => {
  const intl = useIntl()

  const columns = [
    {
      title: intl.formatMessage({id: 'deviceConnections.deviceName'}),
      dataIndex: ['device_data', 'name'],
      key: 'device_name',
      sorter: (a, b) =>
        (a.device_data?.name || '').localeCompare(
          b.device_data?.name || ''
        ),
      render: (text) => (
        <Tooltip title={text}>
          <span>{formatEmptyValue(text)}</span>
        </Tooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'deviceConnections.signalName'}),
      dataIndex: ['signal_obj', 'label'],
      key: 'signal_name',
      sorter: (a, b) =>
        (a.signal_obj?.label || '').localeCompare(
          b.signal_obj?.label || ''
        ),
      render: (text) => (
        <Tooltip title={text}>
          <span>{formatEmptyValue(text)}</span>
        </Tooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'deviceConnections.pinFrom'}),
      dataIndex: 'pin_from',
      key: 'pin_from',
      sorter: (a, b) =>
        (a.pin_from || '').localeCompare(b.pin_from || ''),
      render: (text) => (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'deviceConnections.pinTo'}),
      dataIndex: 'pin_to',
      key: 'pin_to',
      sorter: (a, b) =>
        (a.pin_to || '').localeCompare(b.pin_to || ''),
      render: (text) => (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'deviceConnections.actions'}),
      key: 'actions',
      width: 120,
      align: 'right',
      render: (_, record) => (
        <TableActions
          actions={[
            { key: 'edit', label: intl.formatMessage({id: 'forms.edit'}), icon: <EditOutlined />, onClick: () => onEdit(record) },
            { key: 'delete', label: intl.formatMessage({id: 'forms.delete'}), icon: <DeleteOutlined />, danger: true, onClick: () => onDelete(record) },
          ]}
        />
      ),
    },
  ]

  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        scroll={dataSource?.length ? {x: 'max-content'} : undefined}
        pagination={{
          current: pagination?.currentPage,
          pageSize: 10,
          total: pagination?.totalCount,
          showSizeChanger: false,
          hideOnSinglePage: true,
          showTotal: (total) => <RecordsCount count={total} />,
          onChange: (page) => {
            const offset = (page - 1) * 10
            const url = pagination?.nextPageLink
              ? new URL(pagination?.nextPageLink)
              : new URL(pagination?.prevPageLink)
            url.searchParams.set('offset', offset)
            getDeviceConnectionsData(url.toString())
          },
        }}
        locale={{
          emptyText: (
            <div style={{padding: '40px'}}>
              <Empty description={<RecordsCount count={0} />} />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </>
  )
}

export default DeviceConnectionTable
